<div class="mybets-betslip-info_pick-name bold highlight" *ngIf="isBasicOptionName; else xcastOptionName">{{ bet.optionName }}</div>

<ng-template #xcastOptionName>
    @if (participantNames && participantNames.length > 1) {
        <div class="mybets-betslip-info_pick-name highlight font-big">
            <span *ngFor="let p of participantNames; index as i; last as isLast">
                <span class="mybets-pick_name__participant_pos">{{ sitecoreMyBets.myBets[i + 1] }}</span>
                <span class="mybets-pick_name__participant_name">
                    <strong>{{ p }}</strong>
                    <ng-container *ngIf="!isLast">, </ng-container>
                </span>
            </span>
        </div>
    }
</ng-template>
